(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fss-new-drop"] && !Shopify.designMode) return;
  try {
    
(() => {
 const bind = root => {
  if (!root || root.dataset.ndBound) return;
  root.dataset.ndBound = 'true';
  const status = root.querySelector('[data-nd-status]');
  let saved = [];
  try { const value = JSON.parse(localStorage.getItem('freestyleshop-saved') || '[]'); if (Array.isArray(value)) saved = value.map(String); } catch {}
  const syncSaved = () => root.querySelectorAll('[data-nd-save]').forEach(b => b.setAttribute('aria-pressed', String(saved.includes(b.dataset.ndSave))));
  syncSaved();
  root.addEventListener('click', e => {
   const save = e.target.closest('[data-nd-save]');
   if (save) {
    const id = save.dataset.ndSave;
    const removing = saved.includes(id);
    const next = removing ? saved.filter(v => v !== id) : [...saved, id];
    try { localStorage.setItem('freestyleshop-saved', JSON.stringify(next)); saved = next; syncSaved(); status.textContent = removing ? status.dataset.removed : status.dataset.saved; } catch { status.textContent = status.dataset.saveFailed; }
   }
   const arrow = e.target.closest('[data-nd-slide]');
   if (arrow) { const track = root.querySelector('[data-nd-track]'); track.scrollBy({left: Number(arrow.dataset.ndSlide) * track.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}); }
  });
  root.addEventListener('change', e => {
   if (!e.target.matches('[data-nd-variant]')) return;
   const card = e.target.closest('[data-nd-product]');
   const option = e.target.selectedOptions[0];
   if (option.dataset.price) card.querySelector('[data-nd-price]').textContent = option.dataset.price;
   if (option.dataset.image) { const img = card.querySelector('.nd-card-image'); if (img) { img.removeAttribute('srcset'); img.src = option.dataset.image; } }
  });
  root.addEventListener('keydown', e => { if (e.key === 'Escape') { const menu = root.querySelector('.nd-menu'); if (menu.open) { menu.open = false; menu.querySelector('summary').focus(); } } });
  const track = root.querySelector('[data-nd-track]');
  const arrows = root.querySelectorAll('[data-nd-slide]');
  const syncArrows = () => arrows.forEach(b => { b.disabled = Number(b.dataset.ndSlide) < 0 ? track.scrollLeft <= 1 : track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; });
  track.addEventListener('scroll', syncArrows, {passive:true});
  new ResizeObserver(syncArrows).observe(track);
  syncArrows();
 };
 const init = () => document.querySelectorAll('.nd-home').forEach(bind);
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
 document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
